import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  groupBy,
} from 'lodash';
import moment from 'moment';
import QRCode from 'qrcode.react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { injectIntl } from 'components';

class LabelPrint extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
  };

  static propTypes = {
    info: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    loading: PropTypes.bool.isRequired,
    formatMessage: PropTypes.func.isRequired,
    currentSize: PropTypes.string.isRequired,
  };

  static defaultProps = {
    info: [],
  };

  getInfo = () => {
    const { currentUser, isDistributor } = this.context;
    const { info } = this.props;
    const resultInfo = [];

    if (!info) return [];
    let groupedInfo = [];
    if (isDistributor) {
      groupedInfo = groupBy(info, item => item.data.seller.companyName);
      const groupKeys = Object.keys(groupedInfo);
      groupKeys.forEach((key, index) => {
        const detailInfo = groupedInfo[key];
        resultInfo.push([{ title: `${key} - ${get(currentUser, 'account.profile.companyName')}` , companyName: `${get(currentUser, 'account.profile.companyName')}` } ]);
        const itemData = [];
        detailInfo.forEach(({
          order: { deliveryDate, contact: { buyerCompanyCode, sellerCompanyCode }, buyer },
          data: { packrows, productData: { name, subname }, seller },
          orderId,
          quantity,
        }) => {
          packrows.forEach((packrow) => {
            itemData.push({
              avatar: get(currentUser, 'account.profile.logoUrl'),
              buyerCompanyCode,
              deliveryDate,
              itemName: name,
              itemSubName: subname,
              orderId,
              qty: quantity,
              sellerCompanyCode,
              sourceCompanyName: seller.companyName,
              toCompanyName: buyer.account.profile.companyName,
              uom: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
            });
          });
        });
        resultInfo[index].push(itemData);
      });
    } else {
      groupedInfo = groupBy(info, item => item.order.buyer.account.profile.companyName);
      const groupKeys = Object.keys(groupedInfo);
      groupKeys.forEach((key, index) => {
        const detailInfo = groupedInfo[key];
        resultInfo.push([{ title: `${get(currentUser, 'account.profile.companyName')} - ${key} ` }]);
        const itemData = [];
        detailInfo.forEach(({
          data: { packrows, productData: { name, subname } },
          order: { deliveryDate, contact: { buyerCompanyCode, sellerCompanyCode }, buyer },
          orderId,
          quantity,
        }) => {
          packrows.forEach((packrow) => {
            itemData.push({
              avatar: get(currentUser, 'account.profile.logoUrl'),
              buyerCompanyCode,
              deliveryDate,
              itemName: name,
              itemSubName: subname,
              orderId,
              qty: quantity,
              sellerCompanyCode,
              sourceCompanyName: get(currentUser, 'account.profile.companyName'),
              toCompanyName: buyer.account.profile.companyName,
              uom: `${packrow.count} ${packrow.uom} ${packrow.pack}`,
            });
          });
        });
        resultInfo[index].push(itemData);
      });
    }

    return resultInfo;
  }

  render() {
    const { loading, formatMessage,currentSize } = this.props;
    const { isDistributor } = this.context;
    const info = this.getInfo();
    return (
      <div className="label-print-preview print-thermal-size">
        {
          loading && (
            <div className="print-progress">
              <CircularProgress />
            </div>
          )
        }
        {
          
          info.map(item => (
            <div key={item[0].title}>
              <div className={currentSize === 'normal' ? "labels row" : "labels-4x6 labels row" }>
                {
                  item[1].length ? item[1].map((labelInfo, index) => (
                    <div className={currentSize === 'normal' ? "label page-break col-sm-6" :"label-4x6 label page-break col-sm-6"} key={index}>
                      <div className="header">
                        <QRCode
                          size={130}
                          value={`order - ${labelInfo.orderId}`}
                        />
                        {
                          labelInfo.avatar ? (<img src={labelInfo.avatar} alt="" />) :
                            (<div />)
                        }
                        <div className="deliveryDate">
                          {`${moment(labelInfo.deliveryDate).format('MMM DD')}`}
                        </div>
                      </div>
                      { isDistributor && 
                        <div className="label-company-name"> 
                          <div className="company-name">{item[0].companyName}</div>
                        </div>
                      }
                      
                      <div style={ isDistributor ? {justifyContent: 'left'} : {} } className="title">
                        <div className="item-name">
                          {labelInfo.itemName !== '' ?
                            labelInfo.itemName : 'X'
                          }, {labelInfo.itemSubName !== '' ?
                            labelInfo.itemSubName : 'X'}
                        </div>
                      </div>
                      <div className="main-content">
                        <div className="item-uom-farmer">
                          {labelInfo.uom !== '' ?
                            labelInfo.uom : 'X'
                          }
                        </div>
                        <div className="company-name">
                          {labelInfo.sellerCompanyCode && (
                            <span style={{
                              color: 'red',
                              marginRight: 10,
                            }}>
                              {labelInfo.sellerCompanyCode}
                            </span>
                          )}
                          {labelInfo.sourceCompanyName !== '' ?
                            labelInfo.sourceCompanyName : 'X'
                          }
                        </div>
                      </div>
                      <div className="comanyName">
                        {labelInfo.buyerCompanyCode && (
                          <span style={{
                            color: 'red',
                            marginRight: 10,
                          }}>
                            {labelInfo.buyerCompanyCode}
                          </span>
                        )}
                        {labelInfo.toCompanyName}
                      </div>
                      <div className="footer">
                        <div className="transaction-id">
                          {formatMessage('Transaction ID')}:{labelInfo.orderId}
                        </div>
                        <div className="copyright">
                          {formatMessage('Powered by')} FRESH<span className="small-r">r</span>.com (C) {moment().format('YYYY')}
                        </div>
                      </div>
                    </div>
                  )) : ''
                }
              </div>
              <br />
            </div>
          ))
        }
      </div>
    );
  }
}

const wrappedLabelPrint = injectIntl(LabelPrint);
wrappedLabelPrint.displayName = 'LabelPrint';

export default wrappedLabelPrint;
